import { IconWrapper } from '../runtime';
export default IconWrapper('brush', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.54279 3.96112C6.54279 3.96112 5.5126 5.16331 4.04854 5.85246C3.04263 6.32595 1.86798 6.43748 1.31475 6.47858C1.11435 6.49346 0.970881 6.68782 1.03837 6.87709C1.33074 7.69704 2.15004 9.67805 3.69591 11.2239C5.82205 13.3501 7.35482 14.1917 7.83831 14.4261C7.93747 14.4742 8.05256 14.4561 8.13671 14.3849C8.52204 14.0593 9.63626 13.1077 10.3473 12.3985C11.2384 11.5095 12.533 9.95135 12.533 9.95135M13.0123 10.0064C12.8952 10.1236 12.7052 10.1236 12.5881 10.0064L6.32481 3.74315C6.20766 3.62599 6.20766 3.43604 6.32481 3.31888L7.00516 2.63853C7.59095 2.05275 8.54069 2.05275 9.12648 2.63853L10.483 3.99503L12.0867 1.97389C12.6918 1.21131 13.8262 1.1462 14.5146 1.83455C15.2064 2.52635 15.1366 3.6676 14.3657 4.26998L12.3404 5.85246L13.6927 7.20475C14.2785 7.79053 14.2785 8.74028 13.6927 9.32607L13.0123 10.0064Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});